@import 'node_modules/@glidejs/glide/src/assets/sass/glide.core';

.glide {
  width: 100%;
}

.slide-title {
  float: left;
}

.glide__track {
  display: flex;
}

.glide__slides {
  flex-shrink: 0;
}

.slide-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: calc(2 * var(--spacer));
  height: 100%;
}

:host {
  display: block;
  max-width: 100%;
  position: relative;
  height: 100%;
}

.glide {
  margin-top: calc(3 * var(--spacer));

  &__pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--spacer);
    margin-bottom: calc(2 * var(--spacer));
  }
}

.box {
  background-color: var(--white-layout-300-primary);
  border-radius: 4px;
  height: 100%;
  flex: 1;
  border: 1px solid;
  border-color: var(--chart-101-pressed-dividers);
  color: var(--body-text-arrows-400);
  position: relative;
}

.glide-nav-button::part(button) {
  --button-max-width: 40px;
  min-width: 40px;
  margin-left: var(--spacer);
}

.loading-news {
  margin-top: calc(3 * var(--spacer));

  .news-card {
    padding: 0;
    border-radius: 4px;
    border: 1px solid;
    border-color: var(--chart-101-pressed-dividers);
    flex: 1;

    .image-placeholder {
      height: 223px;
      background-color: var(--grey-layout-200-disabled);
    }

    .news-footer {
      padding: calc(var(--spacer) * 6) calc(var(--spacer) * 3) calc(var(--spacer) * 6) calc(var(--spacer) * 3);
    }
  }

  .news {
    margin-top: calc(3 * var(--spacer));
  }

  .group {
    display: flex;
    gap: calc(2 * var(--spacer));
    margin-top: calc(2 * var(--spacer));
  }

  gz-loader {
    --loader-height: 40px;
    --loader-border-radius: 20px;
    --loader-padding-bottom: calc(4 * var(--spacer));
  }
}
